module.exports = __webpack_public_path__ + "static/media/mainimg-02.198b3a9b.png";